import {Ticket} from '../types';
import {SaveReply, replyForSharing} from '../services/replies';
import {useWorkspace} from '../workspace/WorkspaceContext';
import {api} from '../api';
import {errorMessage} from '../errors';
import {toast} from '../components/ui/sonner';

interface Options {ticket: Ticket; dirty: boolean; tone: string; save: SaveReply}
export function useTicketOperations({ticket, dirty, tone, save}: Options) {
  const {update, generate, refresh, setSelected} = useWorkspace();
  async function resolve(): Promise<void> {
    try {
      if (!(await replyForSharing(ticket, dirty, save))) return;
      const reopening = ticket.status === 'resolved';
      await update(ticket.id, {status: reopening ? 'drafted' : 'resolved'});
      toast.success(reopening ? 'Ticket reopened' : 'Conversation resolved');
    } catch (error: unknown) { toast.error(errorMessage(error)); }
  }
  function regenerate(): void {
    if (dirty && !window.confirm('Replace your unsaved draft with a new reply?')) return;
    void generate(ticket.id, tone);
  }
  async function remove(): Promise<void> {
    try { await api(`/tickets/${ticket.id}`, {method: 'DELETE'}); setSelected(null); await refresh(); toast.success('Ticket deleted'); }
    catch (error: unknown) { toast.error(errorMessage(error)); }
  }
  return {resolve, regenerate, remove};
}